import { useState, useEffect } from "react";

type ScrollDirection = "top" | "bottom" | null;

const ScrollableContainer = () => {
  const [isScrolling, setIsScrolling] = useState<boolean>(false);
  const [scrollDirection, setScrollDirection] = useState<ScrollDirection>(null);
  const scrollSpeed = 20;

  useEffect(() => {
    let scrollInterval: NodeJS.Timeout | undefined;

    if (isScrolling && scrollDirection) {
      scrollInterval = setInterval(() => {
        if (scrollDirection === "top") {
          window.scrollBy(0, -scrollSpeed);
        } else if (scrollDirection === "bottom") {
          window.scrollBy(0, scrollSpeed);
        }
      }, 20);
    }

    return () => {
      if (scrollInterval) clearInterval(scrollInterval);
    };
  }, [isScrolling, scrollDirection]);

  const handleMouseEnter = (direction: ScrollDirection) => {
    setIsScrolling(true);
    setScrollDirection(direction);
  };

  const handleMouseLeave = () => {
    setIsScrolling(false);
    setScrollDirection(null);
  };

  return (
    <>
      <div
        className="fixed left-0 right-0 top-0 z-50 flex h-24 cursor-pointer items-center justify-center bg-gradient-to-b from-black/60 via-black/30 to-transparent shadow-md transition-all duration-300"
        onDragOver={() => handleMouseEnter("top")}
        onDragLeave={handleMouseLeave}
      ></div>
      <div
        className="fixed bottom-0 left-0 right-0 z-50 flex h-24 cursor-pointer items-center justify-center bg-gradient-to-t from-black/60 via-black/30 to-transparent shadow-md transition-all duration-300"
        onDragOver={() => handleMouseEnter("bottom")}
        onDragLeave={handleMouseLeave}
      ></div>
      {/* Example content to enable scrolling */}
      {/* <div style={{ height: "3000px" }} /> */}
    </>
  );
};

export default ScrollableContainer;
